var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"地区筛选","clearable":""},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }